<template>
  <svg width="20" height="20" viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M208 96C190.3 96 176 110.3 176 128L176 512C176 529.7 190.3 544 208 544L432 544C449.7 544 464 529.7 464 512L464 128C464 110.3 449.7 96 432 96L208 96zM144 128C144 92.7 172.7 64 208 64L432 64C467.3 64 496 92.7 496 128L496 512C496 547.3 467.3 576 432 576L208 576C172.7 576 144 547.3 144 512L144 128zM288 464L352 464C360.8 464 368 471.2 368 480C368 488.8 360.8 496 352 496L288 496C279.2 496 272 488.8 272 480C272 471.2 279.2 464 288 464z"
      fill="currentColor"
    />
  </svg>
</template>
